module.exports = __webpack_public_path__ + "static/beargrylls-389ddced841afa7b31464589ea7a6989.png";